import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

var PREFIX = "KSectionTitleWidget";
var classes = {
    chipContainer: "".concat(PREFIX, "-chipContainer"),
    chip: "".concat(PREFIX, "-chip"),
    content: "".concat(PREFIX, "-content")
};
var StyledKSectionTitleWidget = styled(Box)(function () { return ({}); });

export { classes, StyledKSectionTitleWidget as default };
//# sourceMappingURL=index.styled.js.map
